import CloseIcon from '@/components/Icons/CloseIcon';
import RawHtml from '@/components/RawHtml/RawHtml';
import { useAppContext } from '@/contexts/AppContext';
import { useEffect, useState, type FC } from 'react';

const BANNER_STORAGE_KEY = 'banner-dismissed';

const Banner: FC = () => {
  const { community } = useAppContext();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const wasDismissed = sessionStorage.getItem(BANNER_STORAGE_KEY) === 'true';

    setIsVisible(
      !wasDismissed &&
        !!community?.websiteDetails?.bannerText &&
        !!community.websiteDetails?.showBanner,
    );
  }, [community?.websiteDetails?.bannerText, community.websiteDetails?.showBanner]);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem(BANNER_STORAGE_KEY, 'true');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="w-full bg-accent-600 text-white">
      <div className="max-w-7xl mx-auto px-4 py-3 sm:px-6 lg:px-8 flex items-center">
        <div className="flex-1 text-center text-sm sm:text-base font-medium">
          <RawHtml html={community.websiteDetails?.bannerText} />
        </div>
        <button
          onClick={handleClose}
          className="ml-4 shrink-0 p-1 hover:bg-accent-700 rounded-none transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-accent-600"
          aria-label="Close banner"
        >
          <CloseIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Banner;
